var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 2.00167C4.6865 2.00167 2.00021 4.68796 2.00021 8.00167C2.00021 11.3154 4.6865 14.0017 8.00021 14.0017C11.3139 14.0017 14.0002 11.3154 14.0002 8.00167C14.0002 4.68796 11.3139 2.00167 8.00021 2.00167ZM1.14307 8.00167C1.14307 4.21482 4.21335 1.14453 8.00021 1.14453C11.7871 1.14453 14.8574 4.21482 14.8574 8.00167C14.8574 11.7885 11.7871 14.8588 8.00021 14.8588C4.21335 14.8588 1.14307 11.7885 1.14307 8.00167ZM5.14307 6.00167C5.14307 5.77435 5.23337 5.55633 5.39412 5.39558C5.55486 5.23484 5.77288 5.14453 6.00021 5.14453H10.0002C10.2275 5.14453 10.4456 5.23484 10.6063 5.39558C10.767 5.55633 10.8574 5.77435 10.8574 6.00167V10.0017C10.8574 10.229 10.767 10.447 10.6063 10.6078C10.4456 10.7685 10.2275 10.8588 10.0002 10.8588H6.00021C5.77288 10.8588 5.55486 10.7685 5.39412 10.6078C5.23337 10.447 5.14307 10.229 5.14307 10.0017V6.00167Z",
    fill: "#23273B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/record.a037a3f088f52fb57848980b8e193592.svg";
export { ForwardRef as ReactComponent };